import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';

const Freebet = ({ freebet }) => {
    const [ t ] = useTranslation();
    const { selectedFreebet, selectFreebet } = useKeyboard();
    const isSelectedFreebet = freebet.id === selectedFreebet?.id;
    const classes = classNames('fullslip__freebet', {
        'fullslip__freebet--selected': isSelectedFreebet,
    });

    const setFreebet = (freebet) => {
        const toggleFreebet = (selectedFreebet !== freebet) ? freebet : null;
        selectFreebet(toggleFreebet);
    };

    return (
        <div
            className={classes}
            onClick={() => {
                setFreebet(freebet);
            }}
            data-spectate-product={`new-betslip;stake-area;free-bet-${freebet.value}`}
        >
            <div className="fullslip__freebet--title">{t('betslip.freebet')}</div>
            <div className="fullslip__freebet--value">{freebet.value}</div>
        </div>
    );
};

Freebet.propTypes = {
    freebet: PropTypes.object,
};

export default Freebet;
